// export const endPoint = "http://localhost:2000"
export const endPoint = "https://giveawayshop-backend.vercel.app"